import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import withConfig from '@/config/withConfig';
import {resetSelectedSpot} from 'store/spot/spot-actions';
import {userLogout} from 'store/user/user-actions';
import Navigation from '../../navigation';
import {Box} from '@spothero/ui';
import {headerStyles} from '../headerStyles';

const HeaderMobile = ({isProduction, expandedData, collapsedData}) => {
    const dispatch = useDispatch();
    const {data: user} = useSelector(state => state.user);
    const clearSelectedSpot = () => {
        dispatch(resetSelectedSpot());
    };
    const onUserLogout = () => {
        dispatch(userLogout());
    };

    return (
        <Box {...headerStyles} as="header" role="banner" data-testid="Header">
            <Navigation
                isProduction={isProduction}
                user={user}
                collapsedData={collapsedData}
                expandedData={expandedData}
                onItemSelected={clearSelectedSpot}
                onUserLogout={onUserLogout}
            />
        </Box>
    );
};

HeaderMobile.propTypes = {
    isProduction: PropTypes.bool,
    expandedData: PropTypes.array.isRequired,
    collapsedData: PropTypes.array.isRequired,
};

export default withConfig(['isProduction'])(HeaderMobile);
